//const isDevelopmentMode = () => process.env.NODE_ENV === 'development';
//const getBaseApiUrl = () => (isDevelopmentMode() ? process.env.API_URL : '');
const isDevelopmentMode = () => ENV_MODE === 'development';
const getApiUrl = () => (isDevelopmentMode() ? API_URL : '');
const getCurrentApp = () => APP;
// console.log('process.env.NODE_ENV', process.env.NODE_ENV);
export { getApiUrl, getCurrentApp, isDevelopmentMode };
